import React from 'react';
export var AuthenticationContext = React.createContext({
    isAuthenticated: false,
});
export var AuthenticationProvider = function (_a) {
    var isAuthenticated = _a.isAuthenticated, children = _a.children;
    return React.createElement(AuthenticationContext.Provider, { value: { isAuthenticated: isAuthenticated } }, children);
};
//# sourceMappingURL=authentication-provider.js.map